module.exports = __webpack_public_path__ + "static/26-09d6e079196b11fed0c2b765037e218b.png";